import React from "react"
import Poi from "../models/poi"
import { graphql, useStaticQuery } from "gatsby"
//import { useLocalization } from "gatsby-theme-i18n"
import { useI18next } from "gatsby-plugin-react-i18next"
import shuffle from "utils/shuffle"

const useCollectionPois = ({
  category,
  type,
  limit,
  order,
  displayOnMap,
} = {}) => {
  //const { locale } = useLocalization()
  const { language: locale } = useI18next()

  const data = useStaticQuery(graphql`
    query AllCollectionPoisQuery {
      pois: allCollectionPois {
        nodes {
          id
          date
          order
          title
          teaserExcerpt
          country
          city
          email
          phone
          state
          street
          zipCode
          displayOnMap
          latitude
          longitude
          url
          locale
          category {
            title
            slug
          }
          type: poiType {
            title
            slug
          }
          teaserImage {
            localImage {
              childImageSharp {
                gatsbyImageData(width: 400, height: 300)
              }
            }
          }
        }
      }
    }
  `)

  /**
   * Get all POIs in the current locale
   * and apply filters if needed
   */
  return React.useMemo(() => {
    let pois = data.pois.nodes.filter(n => n.locale === locale)

    if (category) {
      pois = pois.filter(
        item => item.category && item.category.some(c => c.slug === category)
      )
    }

    if (type) {
      pois = pois.filter(
        item => item.type && item.type.some(c => c.slug === type)
      )
    }

    if (displayOnMap) {
      pois = pois.filter(item => item.displayOnMap)
    }

    switch (order) {
      case "listOrder":
        pois.sort((a, b) => a.order - b.order)
        break

      case "random":
        pois = shuffle(pois)
        break

      case "oldest":
        pois.sort((a, b) => new Date(a.date) - new Date(b.date))
        break

      case "latest":
      default:
      // nothing to do, this is the natural order
    }

    if (limit) {
      pois = pois.slice(0, limit)
    }

    pois = pois.map(poi => new Poi(poi))

    return pois
  }, [data, locale, type, category, limit, order, displayOnMap])
}

export default useCollectionPois
